module.exports = __webpack_public_path__ + "img/product2_11B984_date.1e53e76a.png";